import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
// import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";

import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";

import 'primereact/resources/themes/lara-light-indigo/theme.css'; // Theme
import 'primereact/resources/primereact.min.css';                 // PrimeReact core styles
import 'primeicons/primeicons.css';                               // PrimeIcons (if used)
import { persistor, store } from './core/data/redux/store'
import { PersistGate } from "redux-persist/integration/react";
import "leaflet/dist/leaflet.css";
// import { PersistGate } from "redux-persist/integration/react";
// import { persistor, store } from "./store/index";
import App from "./App";



const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(

  // <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter basename="/">
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  // </React.StrictMode>
);
